import React from "react";
import { TabPane, Row, Col, Label, Button } from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { changeEmail } from "../../../../slices/auth/profile/thunk";
import Swal from "sweetalert2";

const ChangeEmail = ({ currentUser }) => {
  const dispatch = useDispatch();

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is Required"),
    password: Yup.string().required("Password is Required"),
  });

  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await dispatch(changeEmail(values.email, values.password));

      if (response.error) {
        return Swal.fire({
          title: "Error!",
          text: response.message || "An error occurred",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      Swal.fire({
        title: "Success!",
        text: response.message || "Please check your email for verification",
        icon: "success",
        confirmButtonText: "Ok",
      });
      resetForm();
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error!",
        text: "An error occurred",
        icon: "error",
        confirmButtonText: "Ok",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <TabPane tabId="2">
      <Col lg={12} className="mb-4">
        <div className="">
          <div className="mb-2">
            <div className="d-flex justify-content-between algin-items-center mb-n2">
              <h4 className="text-dark fw-semibold">Change Email</h4>
            </div>
            <hr />
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ isSubmitting, dirty, isValid }) => (
              <Form>
                <Row>
                  <div className="col-6 mt-4">
                    <Label htmlFor="email" className="form-label">
                      New Email
                    </Label>
                    <Field type="email" name="email" className="form-control" placeholder="Enter new email address" />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                  <div className="col-6 mt-4">
                    <Label htmlFor="password" className="form-label">
                      Current Password
                    </Label>
                    <Field type="password" name="password" className="form-control" placeholder="Enter your password" />
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Row>
                <div className="mt-2 mb-4">
                  <small className="text-muted">
                    You will receive a verification email at the new address. Click the link in the email to confirm the change.
                  </small>
                </div>
                <div className="d-flex justify-content-start mt-3">
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting || !dirty || !isValid}
                    className="mb-0"
                  >
                    {isSubmitting ? "Sending verification email..." : "Request Email Change"}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Col>
    </TabPane>
  );
};

export default ChangeEmail;
